import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { toast } from 'sonner';
import GigCodeOfConductModal from './GigCodeOfConductModal';

/**
 * CoCReacceptGate — when the platform publishes a NEW Code of Conduct
 * version, any talent with upcoming accepted bookings under an older
 * version is prompted (on next login / app load) to re-accept the latest
 * policy. Mount once inside the talent shell.
 */
export const CoCReacceptGate = () => {
  const [open, setOpen] = useState(false);
  const [version, setVersion] = useState(null);
  const [count, setCount] = useState(0);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get('/talent/coc/reaccept-status');
        if (cancelled) return;
        if (r.data?.needs_reaccept) {
          setVersion(r.data.active_version);
          setCount((r.data.bookings || []).length);
          setOpen(true);
        }
      } catch (e) { /* silent */ }
    })();
    return () => { cancelled = true; };
  }, []);

  const reaccept = async (versionId) => {
    setBusy(true);
    try {
      const r = await api.post('/talent/coc/reaccept', { coc_version_id: versionId, coc_agreed: true });
      toast.success(`Code of Conduct updated — re-accepted for ${r.data?.updated || count} upcoming gig${(r.data?.updated || count) === 1 ? '' : 's'}.`);
      setOpen(false);
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : (d?.message || 'Could not record acceptance.'));
    } finally { setBusy(false); }
  };

  if (!open || !version) return null;

  return (
    <GigCodeOfConductModal
      open={open}
      version={version}
      busy={busy}
      submitLabel="I Agree to the Updated Code"
      heading="Updated Code of Conduct"
      onClose={() => setOpen(false)}
      onAgree={reaccept}
    />
  );
};

export default CoCReacceptGate;
